import { ButtonWithIcon } from '@ui/button';
import styles from './styles.module.css';

export const StorageFilter = () => (
  <ButtonWithIcon className={styles.filter} icon="IconFilter" iconPosition="left">
    фильтр
  </ButtonWithIcon>
);
